// extracted by mini-css-extract-plugin
export default {"price":"Lka-z","onSale":"Mka-z","msrpLabelPrice":"Nka-z","msrpLabel":"Oka-z","originalPrice":"Pka-z"};